/* eslint-disable import/prefer-default-export */
import icon from '../assets/ARES Favicon.ico';

export const aresConfig = {
  title: 'Ares Scientific',
  catalog: 'partner',
  partner: 'ares',
  origin: 'https://aresscientific.com/',
  host: 'https://chairs.aresscientific.com',
  logo: 'https://ecomseating.s3.amazonaws.com/images/other/ares-logo.png',
  logoURL: 'https://ecomseating.s3.amazonaws.com/images/other/ares-logo-3.png',
  buildAChair: 'ares',
  businessInfo: 'ARES Distribution, LLC, 6538 Collins Ave, Suite 325, Miami Beach, FL 33141',
  headerTheme: '#FFFFFF',
  secondaryTheme: '#C3C94D',
  footerTheme: '#231F20',
  headerTextColor: '#231F20',
  footerTextColor: '#FFFFFF',
  buttonTextColor: '#000000',
  extraAttributes: {
    trackId: 'G-QX56VPGZ0M',
    icon,
  },
};
